import { createFileRoute } from '@tanstack/react-router'
import { futureInternshipSearchSchema } from '@/features/future-internships/filter-future-internships/model/futureInternshipSearch'
import { FutureInternshipsPage } from '@/pages/vacancies/ui/FutureInternshipsPage'

export const Route = createFileRoute('/future-internships')({
  validateSearch: futureInternshipSearchSchema,
  component: FutureInternshipsPage,
})
